import { Component, ChangeDetectionStrategy } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { ConfigurationEmailJobsService } from './configuration-email-jobs.service';
import { ConfigurationEmailJobsTab1Part } from './tabs/tab-1/configuration-email-jobs-tab-1.part';
import { ConfigurationEmailJobsTab2Part } from './tabs/tab-2/configuration-email-jobs-tab-2.part';
import { ConfigurationEmailJobsViewsPart } from './views/email-jobs-views.part';

@Component({
	selector: 'configuration-email-jobs-page',
	standalone: true,
	imports: [
		ConfigurationEmailJobsTab1Part,
		ConfigurationEmailJobsTab2Part,
		ConfigurationEmailJobsViewsPart,
		PageTab1Directive,
		PageTab2Directive,
		PageTab3Directive,
		PageTabsWidget,
		TrimesterDroplistWidget, DroplistWidget, ToolbarWidget,],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './configuration-email-jobs.page.html',
})
export class ConfigurationEmailJobsPage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;

	constructor(public pageService: ConfigurationEmailJobsService) { }

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}